import Filters from './FiltersContainer';

export default Filters;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Filters/index.js